// extracted by mini-css-extract-plugin
export default {"prices":"CardPrices_prices__dsTFH"};